
import { address, email, mobile } from '../folder/constants/Appconstants'
import React,{useState} from 'react'
import {AiOutlineMail} from 'react-icons/ai'
import {IoMdCall} from 'react-icons/io'
import {IoLocationOutline} from 'react-icons/io5'
import {FiChevronRight} from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import ErrorComponent from '../folder/constants/ErrorComponent'
import toast from 'react-hot-toast'



function Contact() {

  const navigator = useNavigate()

  const [data,setdata] = useState({name:'',email:'',mobile:'',requirment:'',department_website:''})
  const [error,seterror] = useState({name:'',email:'',mobile:'',requirment:'',department_website:''})

  function handleChange(e){
    setdata({...data,[e.target.name]:e.target.value})
    seterror({...error,[e.target.name]:''})
  } 

  const branches = [
    {
      name:"Mumbai",
      location:"No.606/7 Sagartech Plaza B wing,Sakinaka Junction, Andheri-Kurla Road,Mumbai- 400072"
    },
    {
      name:"Chennai",
      location:"6/2, CASA Major Rd, Egmore,Chennai, Tamil Nadu 600008"
    },
    {
      name:"Pune",
      location:"Kothari Plaza,Bibwewadi-Kondwa, Rd,Lullanagar„ Pune, Maharashtra-411040"
    },
    {
      name:"Hyderabad",
      location:"No.2 Banjara Hills, Annapurna Studios Lane, Hyderabad, Telangana 500034"
    },
    {
      name:"Shivamogga",
      location:"Keonics IT Park, Machenahalli, Shivamogga, Karnataka 577222"
    },
    {
      name:"Kolkata",
      location:"Express Tower, 42A, Shakespeare Sarani Rd, Elgin, Kolkata, West Bengal 700017"
    },
    {
      name:"Ahmedabad",
      location:"Astron Tech Park, Satellite Rd,  Ahmadabad, Gujarat – 380015"
    }
  ]

  async function submitData() {
    if(!data.name){
      seterror({...error,name:'This Field is required*'})
    }else if(!data.mobile){
      seterror({...error,mobile:'This Field is required*'})
    }else if(!data.email){
      seterror({...error,email:'This Field is required*'})
    }else if(!data.requirment){
      seterror({...error,requirment:'This Field is required*'})
    }else{
      let sendData = {...data}
      sendData['department_website'] = 'Corp Team'
      const response = await axios.post(`https://fidelitustech.com/api/clients/create`,sendData)
      // console.log("response",response?.data?.status)
      if(response?.status == 201){
        toast.success("Your Query Submitted Successfully!")
        resetForm()
      }
    }
  }

  function resetForm(){
    setdata({name:'',email:'',mobile:'',requirment:'',department_website:''})
    seterror({name:'',email:'',mobile:'',requirment:'',department_website:''})
  }

  return (
    <div className='w-screen h-full bg-gray-50'>
      <div className='relative h-[30vh] md:min-h-[60vh] md:max-h-[60vh] relative bg-contact_us-bg bg-cover bg-no-repeat bg-top'>
          
          <div className='absolute  top-[6%] left-[10%]'>
          <h6 className='font_normal group text-white text-[13px] 2xl:text-[16px] flex items-center'><span onClick={()=>navigator('/')} className='opacity-70 hover:opacity-100 hover:underline cursor-pointer'>Home</span> <FiChevronRight className='mx-2' />  <span className='opacity-70 hover:opacity-100 hover:underline cursor-pointer'>Contact Us</span>  </h6>  
          </div>
          <h1 className='text-white flex font_normal text-[13px] 2xl:text-[16px] p-6 bg-black px-10 md:text-[16px] absolute bottom-0 left-[10%] bg-opacity-70 '><span className='min-w-[4px] block min-h-[18px] max-h-[35px] rounded mt-[-1px] mr-4 bg-[#fff]'></span>We’re here to assist you. Whether you're exploring partnerships, seeking our services, or looking to join our team, feel free to reach out.
          </h1>
      </div>

      <div className='w-[90%] md:w-[80%] mx-auto py-10'>
        <h1 data-aos="fade-left" className='text-[24px] 2xl:text-[27px] font_bold'>Contact Us</h1>
        <h1 data-aos="fade-right" className='text-[14px] 2xl:text-[17px] font_normal'>Visit our main branch with the below mentioned address.</h1>
        

        <div className='md:flex shadow-sm bg-white mt-4'>
           
            <div data-aos="fade-right" className='md:w-[30%] mt-10 mb-10 md:mb-0'>

            <h6 className='pl-8 bg-gray-100 p-2 font_normal text-[15px] 2xl:text-[18px]'>Main Branch </h6>    
            <div >
            <div  className='w-full h-full flex  items-start mt-4 md:border-r pr-4 pl-4'>
            <IoLocationOutline color='#4190ac' size={60} />
            <h6 className='text-[13px] 2xl:text-[16px] font_normal cursor-pointer pl-3'>{address}</h6>
            </div>
            <div  className='w-full h-full flex  items-start mt-4 md:border-r pr-4 pl-4'>
            <IoLocationOutline color='#4190ac' size={24} />
            <h6 className='text-[13px] 2xl:text-[16px] font_normal cursor-pointer pl-3'>  USA OFFICE : 3350 Scott Blvd Bldg, 8 Santa Clara, CA 95054</h6>
            </div>

          

            <div  data-aos-delay="400" className='w-full h-full flex  items-start mt-4 md:border-r pr-4 pl-4'>
            <IoMdCall color='#4190ac' size={15} />
            <h6 className='text-[13px] 2xl:text-[16px] font_normal cursor-pointer  pl-2'>{mobile}</h6>
            </div>

            <div className='w-full h-full flex  items-start mt-4 pr-4 pl-4'>
            <AiOutlineMail color='#4190ac' size={15}/>
            <h6 className='ml-1 text-[13px] 2xl:text-[16px] font_normal cursor-pointer  pl-2'>{email}</h6>
            </div>
            </div>
            </div>


            <div data-aos="fade-left"  className=' md:w-[70%] '>
            <div className='w-[100%]'>
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15555.201402509898!2d77.5725512!3d12.9205498!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14293cbbedf9%3A0x4f12794ce5a209a4!2sFidelitus%20Corp!5e0!3m2!1sen!2sin!4v1691664501989!5m2!1sen!2sin" className='w-full' height="400"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            </div>
        </div>


        <h1 data-aos="fade-left" className='text-[24px] mt-10 2xl:text-[27px] font_bold'>Our Branchs</h1>

        <div className='bg-white shadow-sm  p-5 mt-5'>
            <h6 className='text-[14px] 2xl:text-[17px] font_normal pl-6 mt-4'>Rajajinagar | Whitefield | Mysuru | Hyderabad | Chennai | Mumbai | Delhi | Ahmedabad | Kolkata | Pune | Kochi</h6>
            <h6 className='text-[14px] 2xl:text-[17px] font_normal pl-6 mt-4'></h6>
        </div>

        <h6 data-aos="fade-left"  className='font_bold text-[19px] 2xl:text-[22px] flex mt-10'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span>Write to Us</h6>
        <h1 data-aos="fade-right"  className='text-[14px] 2xl:text-[17px] font_normal pl-6 mt-4'>Simply fill out the form below, and we’ll get back to you shortly. Let’s connect and build something meaningful together!
        </h1>

        <div data-aos="fade-up"  className='bg-white shadow-sm  p-5 mt-5'>
        <div className='flex'>
        <div className='mr-2 w-full'>
        <input type='text' name="name" placeholder='Name' value={data?.name} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-2 pl-2 text-[13px] 2xl:text-[16px] mb-4' />
        <ErrorComponent error={error?.name} />
        <input type='text' name="mobile" placeholder='Contact Number' value={data?.mobile} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-2 pl-2 text-[13px] 2xl:text-[16px] mb-4' />
        <ErrorComponent error={error?.mobile} />
        <input type='text' name="email" placeholder='Email' value={data?.email} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-2 pl-2 text-[13px] 2xl:text-[16px] mb-4' />
        <ErrorComponent error={error?.email} />

        </div>    
        <div className='ml-2 w-full'>
        <textarea type='text' name="requirment" placeholder='Query' value={data?.requirment} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-2 pl-2 text-[13px] 2xl:text-[16px]' />
        <ErrorComponent error={error?.requirment} />
        </div>

        </div> 

       
       <div onClick={submitData} className='flex w-full items-center justify-end'>
        <h6 className='bg-gray-100 cursor-pointer transition-all duration-500 w-max md:w-[80px] text-[14px] 2xl:text-[17px] text-center px-2 py-2 font_normal hover:bg-black hover:text-white'>Submit</h6>
        </div>
        </div>


      </div>   
    </div>
  )
}

export default Contact